import { addBreadcrumb } from '@sentry/react';
import type { AutosaveEvent } from './autosave-coordinator';

const CATEGORY = 'digital-forms.draft';

/**
 * Lifecycle breadcrumbs for autosave/resume (spec §10). Only outcome categories and counts are recorded —
 * never answers, phone digits, birthdate, or verification codes.
 */
export const trackDraftEvent = (
  message: string,
  data?: Record<string, string | number | boolean | undefined>,
  level: 'info' | 'warning' = 'info'
) => {
  addBreadcrumb({ category: CATEGORY, message, level, data });
};

export const trackAutosaveEvent = (event: AutosaveEvent) => {
  switch (event.type) {
    case 'save-success':
      trackDraftEvent('Draft saved', { attempt: event.attempt });
      return;
    case 'save-failure':
      trackDraftEvent(
        'Draft save failed',
        { attempt: event.attempt, category: event.category, status: event.status },
        'warning'
      );
      return;
    case 'retry-scheduled':
      trackDraftEvent('Draft save retry scheduled', { attempt: event.attempt, delayMs: event.delayMs });
      return;
    case 'paused':
      trackDraftEvent('Draft autosave paused after retries', undefined, 'warning');
      return;
    case 'stopped':
      trackDraftEvent('Draft autosave stopped', { category: event.category }, 'warning');
      return;
  }
};
